import { ZendeskUser } from '../useZDUser/useZDUser.interface';

import { ProcessedComments, BotMessage, Comment } from './useTicketComments.interface';

import { BOT_AUTHOR_ID } from 'services/help-center/constants';

export default function processComments(comments: Comment[], zdUser: ZendeskUser | undefined): ProcessedComments {
    if (comments.length < 2) {
        return { botMessage: null, comments };
    }

    const lastCommentIndex = comments.length - 1;
    const lastComment = comments[lastCommentIndex];
    const secondLastComment = comments[lastCommentIndex - 1];

    if (
        lastComment.via?.channel === 'api' &&
        lastComment.author_id === zdUser?.id &&
        secondLastComment.author_id === BOT_AUTHOR_ID &&
        secondLastComment.via?.channel === 'api'
    ) {
        const remainingComments = comments.slice(0, lastCommentIndex - 1);
        const botMessage: BotMessage = {
            initialMessage: lastComment,
            botMessage: secondLastComment,
        };

        return {
            botMessage,
            comments: remainingComments,
        };
    }

    return { botMessage: null, comments };
}
